import { axiosInstance } from '../common/api';


export const getAllFilteredAssets = (params = {}) => {
  // Only append params that actually have a value so we never send
  // `keyword=undefined` etc. to the backend.
  const query = new URLSearchParams();
  const append = (key, value) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  };
  append('keyword', params.keyword);
  append('sortBy', params.sortBy);
  append('sortOrder', params.sortOrder);
  append('page', params.page);
  append('limit', params.limit);
  append('status', params.status);
  append('type', params.type);
  append('category', params.category);
  append('assignedTo', params.assignedTo);

  const url = `/assets?${query.toString()}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const getAssetById = (id) => {
  const url = `/assets/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const deleteAsset=(id)=>{
  const url = `/assets/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const getUsers = () => {
  const url = '/user/all';
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const getAllAssets =()=>{
  const url = '/assets';
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const createAsset = (assetData) => {
  const url = '/assets';
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, assetData)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateAsset = (id, assetData) => {
  const url = `/assets/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, assetData)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAssetHistory = (id) => {
  const url = `/assets/${id}/history`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAssetStats = () => {
  const url = '/assets/stats';
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const bulkUploadAssets = (file) => {
  const url = '/assets/bulk-upload';

  // multipart/form-data with the file under the `file` field.
  const formData = new FormData();
  formData.append('file', file);

  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};